import { getBearerAuthHeaders, refreshAuthToken } from './authToken'

export const coreAppUrl = (path) => {
	const baseUrl = process.env.REACT_APP_CORE_APP_URL
	if (!baseUrl) {
		throw new Error('REACT_APP_CORE_APP_URL is not configured')
	}
	return `${baseUrl}/legacy-documents/${path}`
}

export const coreAppFetch = async (path, init = {}) => {
	const { headers: initHeaders, ...rest } = init
	const headers = await getBearerAuthHeaders(initHeaders)
	const response = await fetch(coreAppUrl(path), {
		...rest,
		headers,
	})
	if (response.status === 401) {
		await refreshAuthToken()
		const retryHeaders = await getBearerAuthHeaders(initHeaders)
		return fetch(coreAppUrl(path), {
			...rest,
			headers: retryHeaders,
		})
	}
	return response
}
